// stores/error-store.ts
import { defineStore } from "pinia";

export type ToastType = "error" | "warning" | "info" | "success";

export interface ToastMessage {
  id: string;
  type: ToastType;
  title: string;
  message: string;
  timestamp: Date;
}

export const useAlertStore = defineStore("alerts", {
  state: () => ({
    toasts: [] as ToastMessage[],
  }),

  actions: {
    addToast(type: ToastType, title: string, message: string) {
      const toast: ToastMessage = {
        id: `${type}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        type,
        title,
        message,
        timestamp: new Date(),
      };
      this.toasts = [...this.toasts, toast];
    },

    addError(title: string, message: string) {
      this.addToast("error", title, message);
    },

    addWarning(title: string, message: string) {
      this.addToast("warning", title, message);
    },

    addInfo(title: string, message: string) {
      this.addToast("info", title, message);
    },

    addSuccess(title: string, message: string) {
      this.addToast("success", title, message);
    },

    removeToast(id: string) {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
    },

    clearToasts() {
      this.toasts = [];
    },
  },
});
